module.exports = __webpack_public_path__ + "media/images/bg_about_kvytok-6eeae4bc51c703a27b22930f88697e52.svg";